export const GOOGLECAST_APP_ID = process.env.REACT_APP_GOOGLE_CAST_APP_ID;
